import { AgentEvent } from '~/atoms/schemas/workflowSchemas';
import { ProcessedEvent } from '../types';
import { getMessageTypeFromEventName } from './getMessageTypeFromEventName';

/**
 * Processes agent events into a map of processed events
 * @param events Array of agent events to process
 * @returns Map of processed events keyed by workflow_id-task_id-index
 */
export const processAgentEvents = (
  events: AgentEvent[],
): Map<string, ProcessedEvent> => {
  return events.reduce((map, event) => {
    // Skip thinking_end events but keep thinking_start and thinking_delta
    if (event.event_name === 'thinking_end') return map;

    const {
      timestamp,
      uuid_run,
      index,
      workflow_id,
      task_id,
      event_name,
      data,
    } = event;
    // Determine the message type from the event name
    const messageType = getMessageTypeFromEventName(event_name);

    const eventData = typeof data === 'string' ? data : JSON.stringify(data);

    const eventKey = `${workflow_id}-${task_id}-${index}`;

    const existingEvent = map.get(eventKey);
    if (existingEvent) {
      map.set(eventKey, {
        ...existingEvent,
        content: existingEvent.content + eventData,
        isComplete: event.event_name.endsWith('_delta') ? false : true,
        workflow_id,
        task_id,
        messageType,
      });
    } else {
      map.set(eventKey, {
        uuid_run,
        index,
        eventName: event.event_name,
        content: eventData,
        timestamp,
        isComplete: !event.event_name.endsWith('_delta'),
        workflow_id,
        task_id,
        messageType,
      });
    }

    return map;
  }, new Map<string, ProcessedEvent>());
};
